module.exports = __webpack_public_path__ + "img/dream2.b82abc6d.jpg";